import React from "react";

import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import ManagedTextField from "utils/edit/ManagedTextField";
import { ChangeEvent } from "utils/history/Event";
import { isEmpty } from "utils/Utils";

import {
	InformationRight,
	InformationRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";
import { UrlField } from "../FieldService";

export type UrlInputProps = {
	field: UrlField;
	editable: boolean;
	rights: InformationRights;

	onChange: (event: ChangeEvent, valid: boolean) => void;
};

const UrlInput: React.FC<UrlInputProps> = (props: UrlInputProps) => {
	function isValid(value: string): boolean {
		return props.field.required ? !isEmpty(value) : true;
	}

	function onChange(newValue: string): void {
		const change = new ChangeEvent("/value", props.field.value, newValue);
		props.onChange(change, isValid(newValue));
	}

	function resolveLink(): string {
		const link = props.field.value;
		if (link.startsWith("http://") || link.startsWith("https://")) {
			return link;
		} else {
			return "https://" + link;
		}
	}

	return (
		<Grid
			item
			container
			xs={12}
			md={6}
			columnSpacing={2}
			alignItems="center">
			<Grid item xs={12} sm={6}>
				<Typography variant="subtitle2" sx={{ wordWrap: "break-word" }}>
					{props.field.name}
					{props.field.required && " *"}
				</Typography>
			</Grid>
			<Grid item xs={12} sm={6}>
				{props.editable &&
				props.rights[props.field.uuid][InformationRight.WRITE] ? (
					<ManagedTextField
						id={props.field.name}
						fullWidth
						required={props.field.required}
						error={!isValid(props.field.value)}
						value={props.field.value}
						onUpdate={onChange}
						variant="standard"
					/>
				) : (
					<Link
						variant="body2"
						href={resolveLink()}
						target="_blank"
						rel="noopener noreferrer"
						sx={{ wordBreak: "break-all" }}>
						{props.field.value}
					</Link>
				)}
			</Grid>
		</Grid>
	);
};

export default UrlInput;
